module.exports = __webpack_public_path__ + "static/Q8Answer6_Oldtownroad_specphotops-5ad71d613ae8cc1639d6841cbd8733f4.jpg";